import { render } from "./reservados.vue?vue&type=template&id=cf46c9c8"
import script from "./reservados.vue?vue&type=script&lang=js"
export * from "./reservados.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__